import React from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { addLocale } from 'primereact/api';

import { localeBr } from '../utils/prime_locales';

export const BrCalendar = ({
    id,
    name,
    value,
    onChange,
    className,
    yearRange,
    readonly,
    placeholder,
    onSelect,
    disabled,
    onClearButtonClick,
    onInput,
    showTime = false,        // Prop para ativar/desativar hora
    timeOnly = false,        // Prop para exibir somente a hora
    hourFormat = "24",       // Formato da hora ("12" ou "24")
    showSeconds = false,     // Prop opcional para exibir segundos
    stepMinute = 1,          // Intervalo de minutos no seletor
    mask                     // Máscara opcional customizada
}) => {

    addLocale(localeBr.name, localeBr.options);

    const monthNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />;
    };

    const yearNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="p-ml-2" style={{ lineHeight: 1 }} />;
    };

    // Define a máscara dinâmica com base nas configurações de tempo
    const getMaskPattern = () => {
        if (mask) return mask;
        if (timeOnly) return showSeconds ? "99:99:99" : "99:99";
        if (showTime) return showSeconds ? "99/99/9999 99:99:99" : "99/99/9999 99:99";
        return "99/99/9999";
    };

    return (
        <Calendar
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            className={className}
            monthNavigator={!timeOnly}
            yearNavigator={!timeOnly}
            yearRange={yearRange}
            monthNavigatorTemplate={monthNavigatorTemplate}
            yearNavigatorTemplate={yearNavigatorTemplate}
            dateFormat="dd/mm/yy"
            locale="br"
            readOnlyInput={readonly}
            placeholder={placeholder}
            showButtonBar={true}
            mask={getMaskPattern()}
            onSelect={onSelect}
            onInput={onInput}
            disabled={disabled}
            onClearButtonClick={onClearButtonClick}
            showTime={showTime}
            timeOnly={timeOnly}
            hourFormat={hourFormat}
            showSeconds={showSeconds}
            stepMinute={stepMinute}
        />
    );
};